import React from 'react'

import { Box, Button, Grid, Typography } from '@mui/material'
import { I18n } from '@front/volcanion'
import { TableHeader, TableRow, SearchFrame, SearchForm, SearchTable, FormContent, SearchCreateButton } from '@front/squirtle'

import Form from './Form'
import Header from './Header'
import Row from './Row'

const ImportList = ({ onRowClick, onClickNewImport }) =>
  <Box sx={{ m: 5 }}>
    <Grid container justifyContent='center'>
      <Grid size={11}>
        <SearchFrame
          model_name={'list'}
          auto_reload
          default_limit={25}
          placementPagination='bottom'
        >
          <SearchCreateButton>
            <Box display='flex' justifyContent='flex-end'>
              <Button onClick={onClickNewImport} variant={'outlined'} sx={{ textTransform: 'none' }}>
                <Typography >{I18n.t('import.new')}</Typography>
              </Button>
            </Box>
          </SearchCreateButton>
          <SearchForm submitOnMount disableButton>
            <FormContent><Form /></FormContent>
          </SearchForm>
          <SearchTable onRowClick={onRowClick} tableProps={{ placementPagination: 'bottom' }}>
            <TableHeader><Header /></TableHeader>
            <TableRow><Row /></TableRow>
          </SearchTable>
        </SearchFrame>
      </Grid>
    </Grid>
  </Box>


export default React.memo(ImportList)
